"use strict";

(function ($, Drupal) {
  Drupal.behaviors.Filters = {
    attach: function attach() {
      /* EXPOSED FILTERS
      Update the labels for the search textboxes for the resources and blog
      */
      $('.resources-search  .js-form-item').children('input').attr('placeholder', 'Search Resource Center');
      /* added place holder in search resource textbox */
      $('.blog-search-section  .js-form-item').children('input').attr('placeholder', 'Type to search');
      $('.js-search-result-section  .js-form-item').children('input').attr('placeholder', 'Type to search');
      /* FILTER LISTS in MOBILE */
      /* BLOG FILTER LIST */
      $('.blog-categary-list h4').click(function () {
        if ($(this).parent('.blog-categary-list').children('ul').css('display') === 'none') {
          $(this).parent('.blog-categary-list').children('ul').slideDown();
          $(this).parent('.blog-categary-list').addClass('active');
        } else {
          $(this).parent('.blog-categary-list').children('ul').slideUp();
          $(this).parent('.blog-categary-list').removeClass('active');
        }
      });
      /*
      RESOURCES FILTER LIST TYPE
      */
      $('.js-resources-type h4').click(function () {
        var windowsize = $(window).width();
        if (windowsize < 981) {
          if ($(this).parent('.js-resources-type').children('ul').css('display') === 'none') {
            $(this).parent('.js-resources-type').children('ul').slideDown();
            $(this).parent('.js-resources-type').addClass('active');
          } else {
            $(this).parent('.js-resources-type').children('ul').slideUp();
            $(this).parent('.js-resources-type').removeClass('active');
          }
        }
      });
      /*
      RESOURCES FILTER LIST INDUSTRY
      */
      $('.js-resources-industry h4').click(function () {
        var windowsize = $(window).width();
        if (windowsize < 981) {
          if ($(this).parent('.js-resources-industry').children('ul').css('display') === 'none') {
            $(this).parent('.js-resources-industry').children('ul').slideDown();
            $(this).parent('.js-resources-industry').addClass('active');
          } else {
            $(this).parent('.js-resources-industry').children('ul').slideUp();
            $(this).parent('.js-resources-industry').removeClass('active');
          }
        }
      });
    }
  };
})(jQuery, Drupal);